import { render } from "./InstanceDetailInfo.vue?vue&type=template&id=6e83b1fa&scoped=true&ts=true"
import script from "./InstanceDetailInfo.vue?vue&type=script&lang=ts"
export * from "./InstanceDetailInfo.vue?vue&type=script&lang=ts"

import "./InstanceDetailInfo.vue?vue&type=style&index=0&id=6e83b1fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e83b1fa"]])

export default __exports__